import { isAfter, parseISO } from 'date-fns';

import { ApiApplicantProfile } from 'api/applicantProfile/types/ApiApplicantProfile';
import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';
import { isDefined } from 'utils/functional';
import {
  NOTIFICATIONS,
  dismissNotification,
  notificationIsDismissed,
} from 'utils/localNotifications';
import { getItem } from 'utils/localStorage';
import { isNonAdmin } from 'utils/userEnvironment';

const NEW_USER_DATE = new Date('2020-11-16T17:00:00Z');

export function dismissResumeDBLoggedOut() {
  return dismissNotification(NOTIFICATIONS.UPLOAD_RESUME);
}

export function hasResumeDb(userEnvironment: MainStoreUserEnvironmentState) {
  return (
    getItem('enableResumeDb') !== false &&
    (userEnvironment.environment?.isUS ||
      userEnvironment.user?.isRecruitable) &&
    CURRENT_LOCALE === 'en'
  );
}

export function hasWorkHistoryJobs(profile?: ApiApplicantProfile) {
  return (
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    profile && profile.workHistoryJobs && profile.workHistoryJobs.length > 0
  );
}

export function promoteResumeDatabase({
  userEnvironment,
  includeDate,
  allowLoggedOut,
}: {
  userEnvironment: MainStoreUserEnvironmentState;
  includeDate?: boolean;
  allowLoggedOut?: boolean;
}) {
  return (
    userEnvironment.isUserLoaded &&
    userEnvironment.isEnvironmentLoaded &&
    hasResumeDb(userEnvironment) &&
    !notificationIsDismissed(NOTIFICATIONS.UPLOAD_RESUME) &&
    ((allowLoggedOut && !userEnvironment.user) ||
      // @ts-expect-error TS(2345): Argument of type 'ApiUser | undefined' is not assi... Remove this comment to see the full error message
      (isNonAdmin(userEnvironment.user) &&
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        (!isDefined(userEnvironment.user.isRecruitable) ||
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          (userEnvironment.user.isRecruitable &&
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            !userEnvironment.user.resumeId)))) &&
    (!includeDate ||
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      isAfter(parseISO(userEnvironment.user.created), NEW_USER_DATE))
  );
}
